import { createFileRoute } from '@tanstack/react-router'

// No requireGuest: after signup the user is already signed in, and the
// verification link must still work for them (the token is the proof).
export const Route = createFileRoute('/verify-email')({
  validateSearch: (raw: Record<string, unknown>) => ({
    token: typeof raw.token === 'string' ? raw.token : '',
  }),
})
